import React from 'react';
import CloseFormWrapper from '../../components/forms/CloseFormWrapper';

/**
 * Zamanat Form Page
 *
 * Public form page for partner applications (Zamanat)
 * No authentication required
 */
const ZamanatForm = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center p-10">
      <div className="w-full max-w-[700px]">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <img
            src={process.env.PUBLIC_URL + '/images/logo.svg'}
            alt="Zamanat Logo"
            className="h-12 w-auto"
          />
        </div>

        <CloseFormWrapper
          formId={process.env.REACT_APP_ZAMANAT_FORM_ID}
          title="Apply to Partner with Zamanat"
          backgroundColor="white"
        />
      </div>
    </div>
  );
};

export default ZamanatForm;
